<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">SKU Master</h4>
                                <h6 class="card-subtitle">All products in the Marketplace</h6>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <router-link :to="{name: 'marketplaceaddproduct', params: {marketplaceid: currentOrg.marketplace_id}}" class="btn btn-success waves-effect waves-light">
                                            <i class="fas fa-plus"></i> Add Product
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body collapse show">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <div class="col-md-2 col-xs-12">
                                    <input type="text" class="form-control" placeholder="Code" v-model="filter.code">
                                </div>

                                <div class="col-md-3 col-xs-12">
                                    <multiselect
                                        :clear-on-select="false"
                                        :close-on-select="true"
                                        :hide-selected="true"
                                        :internal-search="false"
                                        :options="goods"
                                        :searchable="true"
                                        :selectLabel="''"
                                        :show-no-results="false"
                                        class="form-control multiselect-sm"
                                        id="good"
                                        @search-change="searchGoods"
                                        label="Search Product"
                                        name="customer"
                                        open-direction="bottom"
                                        placeholder="Search Product"
                                        v-model="filter.good">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.commodity_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.commodity_name }}</h5>

                                            </div>
                                        </template>
                                        <span slot="noResult">Good not found</span>
                                    </multiselect>
                                </div>

                                <div class="col-md-2 col-xs-12">
                                    <multiselect
                                        :clear-on-select="false"
                                        :close-on-select="true"
                                        :hide-selected="true"
                                        :internal-search="false"
                                        :options="units"
                                        :searchable="true"
                                        :selectLabel="''"
                                        :show-no-results="false"
                                        class="form-control multiselect-sm"
                                        id="unit"
                                        @search-change="searchUnits"
                                        label="Search Good"
                                        name="customer"
                                        open-direction="bottom"
                                        placeholder="Search Unit"
                                        v-model="filter.unit">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.symbol}} - {{props.option.name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.symbol }}</h5>
                                                <div>{{ props.option.name }}</div>
                                            </div>
                                        </template>
                                        <span slot="noResult">Good not found</span>
                                    </multiselect>
                                </div>

                                <div class="col-md-2 col-xs-12">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <button class="btn btn-light waves-effect border"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false">
                                                {{filter.comp}}
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                <a class="dropdown-item" href="#" @click="filter.comp = '='">= Equals To</a>
                                                <a class="dropdown-item" href="#" @click="filter.comp = '>'">&lt; Greater Than</a>
                                                <a class="dropdown-item" href="#" @click="filter.comp = '<'">&gt; Less Than</a>
                                            </div>
                                        </div>
                                        <input type="number" placeholder="Quantity" class="form-control" v-model="filter.quantity">
                                    </div>
                                </div>

                                <div class="col-md-2 col-xs-12">
                                    <div class="btn-group" style="display: flex;">
                                        <button @click="getProducts(1)" class="btn btn-light btn-outline-success font-weight-bold" style="flex: 1" type="button">
                                            <i class="fa fa-search"/> Go!
                                        </button>
                                        <button @click="reset()" class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold" style="flex: 1" type="button">
                                            <i class="fa fa-undo"/> Reset
                                        </button>
                                    </div>
                                </div>

                                <div class="col-md-1 col-xs-12 text-right">
                                <span class="fa-xs fa-stack fa-1x ml-auto text-muted" v-if="exporting" title="Exporting, please wait ...">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>
                                        </span>
                                    <button aria-expanded="false" aria-haspopup="true" class="btn waves-effect waves-light btn-outline-info"
                                            data-toggle="dropdown" title="Operations">
                                        <i class="fa fa-grip-vertical"/>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a @click="exportSkusAsExcel()" class="dropdown-item" href="javascript:void(0)">
                                            <i class="fa fa-file-excel"/> Export SKUs
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                            </div>
                        </div>

                        <div class="table-responsive" v-if="products.length>0">
                            <table class="table no-wrap v-top">
                                <thead>
                                <tr class="border-0 bg-light">
                                    <th class="border-0"><h6>SKU Code</h6></th>
                                    <th class="border-0"><h6>Product</h6></th>
                                    <th class="border-0 text-right"><h6>Quantity</h6></th>
                                    <th class="border-0"><h6>Unit</h6></th>
                                    <th class="border-0"><h6>Timestamp</h6></th>
                                    <th class="border-0 text-center"><h6>Action</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(p, index) in products">
                                    <td>{{p.code}}</td>
                                    <td>{{p.name}} - {{p.variety}}</td>
                                    <td class="text-right">{{p.quantity | unitFix(2)}}</td>
                                    <td>{{p.unit}}</td>
                                    <td>{{p.created_at | timestamp}}</td>
                                    <td class="text-center">
                                        <h6>
                                            <router-link title="Create Label" class="text-cyan" :to="{name: 'marketplaceproductlabel', params : { productid: p.id}}">
                                                <i class="fa fa-qrcode"/>
                                            </router-link>
                                            <router-link title="Details" class="ml-3" :to="{name: 'marketplaceviewproduct', params : { productid: p.id}}">
                                                <i class="fa fa-eye"/>
                                            </router-link>
                                            <router-link title="Edit" class="text-info ml-3" :to="{name: 'marketplaceditproduct', params : { productid: p.id}}">
                                                <i class="fa fa-edit"/>
                                            </router-link>
                                            <a class="text-danger ml-3" data-target="#deleteSku" data-toggle="modal" @click="setSkuIdToDelete(p.id)" href="javascript:void(0)" title="Delete">
                                                <i class="fa fa-trash-alt"/>
                                            </a>
                                        </h6>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <template v-else>
                            <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                            <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try again</h5>
                        </template>
                    </div>
                    <div class="card-footer">
                        <div class="row" v-if="products.length>0">
                            <div class="col-6">
                                <div class="row">
                                    <label class="col-form-label p-l-10" for="records">Display</label>
                                    <div class="col-auto p-t-5">
                                        <select @change="perPageRecordChange()" aria-controls="lang_opt" class="form-control form-control-sm" id="records" name="lang_opt_length"
                                                v-model="perPage">
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <label class="col-form-label" for="records">Records per page</label>
                                </div>
                            </div>
                            <div class="col-6">
                                <paginate
                                    :click-handler="pageHandler"
                                    :container-class="'pagination float-right mb-0'"
                                    :margin-pages="2"
                                    :next-class="'page-link'"
                                    :next-text="'Next'"
                                    :page-class="'page-link'"
                                    :page-count=pageCount
                                    :page-range="3"
                                    :prev-class="'page-link'"
                                    :prev-text="'Prev'">
                                </paginate>
                            </div>
                        </div>
                        <div style="height: 40px;" v-else></div>
                    </div>
                </div>
            </div>
        </div>

        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="deleteSku"
             role="dialog" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body card-blue">
                        <div class="text-center m-t-20 m-b-10">
                            <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                            <br><br>
                            <h4>Are you sure you want to remove this SKU?</h4>
                            <button @click="deleteProduct()"
                                    class="btn waves-effect waves-light btn-success m-r-15" data-dismiss="modal"
                                    type="button">Yes
                            </button>
                            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Paginate from "vuejs-paginate";
import {mapGetters} from "vuex";
import Multiselect from 'vue-multiselect';
import XLSX from "xlsx";

export default {
    name: "MarketplaceSKUMaster",
    props: ["procuctid"],
    components: {Paginate, Multiselect},
    computed: {
        ...mapGetters(["currentUser", "currentOrg"])
    },
    data() {
        return {
            goods: [],
            units: [],
            products: [],
            pageCount: 1,
            total: 0,
            perPage: 10,
            filter: {
                code: null,
                good: null,
                unit: null,
                quantity: null,
                comp: '='
            },
            exporting: false,
            sku_id_to_remove: null
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.getProducts(1);
        },
        async getProducts(page) {
            console.log(this.filter)
            try {
                $(".preloader").fadeIn();
                let filter = {};

                if(this.filter.code) {
                    filter.code = this.filter.code;
                }

                if(this.filter.good) {
                    filter.goodid = this.filter.good.commodity_id;
                }

                if(this.filter.unit) {
                    filter.unitid = this.filter.unit.id;
                }

                if(this.filter.quantity) {
                    filter.quantity = this.filter.quantity;
                    filter.comp     = this.filter.comp;
                }

                let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/products`, {
                    params: {
                        page: page,
                        perPage: this.perPage,
                        ...filter
                    }
                });
                $(".preloader").fadeOut();
                this.total    = reply.data.total;
                this.products = reply.data.skus;
                this.setPageCount();
            } catch(e) {
                console.error(e);
                $(".preloader").fadeOut();
            }
        },
        pageHandler(pageNum) {
            this.getProducts(pageNum);
        },
        setPageCount() {
            this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
        },
        async reset() {
            this.filter = {
                code: null,
                good: null,
                unit: null,
                quantity: null,
                comp: '='
            },
                await this.getProducts(1)
        },
        perPageRecordChange() {
            if(this.isFiltered) {
                this.getProducts(1);
            } else {
                this.getProducts(1);
            }
        },
        async searchGoods(search) {
            this.isLoading = true;
            let reply      = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/commodities/search", {
                params: {
                    search,
                    excludeOld: true
                }
            });
            this.goods     = reply.data;
        },
        async searchUnits(search) {
            this.isLoading = true;
            let reply      = await this.$http.get("/unit/search", {
                params: {
                    search
                }
            });
            this.units     = reply.data;
        },
        setSkuIdToDelete(sku_id){
            this.sku_id_to_remove = sku_id;
        },
        async deleteProduct() {
            try {
                await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/products/${this.sku_id_to_remove}`);
                this.$toastr('success', 'Stock Keeping Unit Deleted', 'Success');
                await this.getProducts(1);
            } catch(e) {
                this.$toastr('error', 'Stock Keeping Unit Deletion Failed', 'Failure');
            }
        },
        async exportSkusAsExcel() {
            try {
                this.exporting = true;
                let filter     = {};

                if(this.filter.code) {
                    filter.code = this.filter.code;
                }

                if(this.filter.good) {
                    filter.goodid = this.filter.good.id;
                }

                if(this.filter.unit) {
                    filter.unitid = this.filter.unit.id;
                }

                if(this.filter.quantity) {
                    filter.quantity = this.filter.quantity;
                    filter.comp     = this.filter.comp;
                }

                let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/products`, {
                    params: {
                        page: 1,
                        perPage: this.total,
                        ...filter
                    }
                });

                let skus = [];

                data.skus.forEach(d => {
                    skus.push({
                        "Code": d.code,
                        "Name": d.name,
                        "Variety": d.variety,
                        "Quantity": Number(d.quantity).toFixed(2),
                        "Unit": d.unit,
                        "Timestamp": d.created_at
                    });
                });

                let workbook = XLSX.utils.book_new();
                let sheet    = XLSX.utils.json_to_sheet(skus);
                XLSX.utils.book_append_sheet(workbook, sheet, 'SKUs');
                XLSX.writeFile(workbook, 'SKUs.xlsx');
            } catch(e) {
                console.error(e)
                this.$toastr('error', 'Export failed', 'Failure');
            } finally {
                this.exporting = false;
            }
        }
    }
}
</script>

<style scoped>

</style>
